<template>
    <div class="yt-field-ckeditor">
        <ckeditor
            :editor="editor"
            v-model="value"
            :config="editorConfig"
            :disabled="disabled"
            :maxlength="schema.max"
            :placeholder="schema.placeholder"
            :readonly="schema.readonly" />
    </div>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { abstractField } from 'vue-form-generator'
import Font from '@ckeditor/ckeditor5-font/src/font'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

@Component({
    mixins: [ abstractField ]
})
export default class FieldCKEditor extends Vue {
    editor = ClassicEditor

    editorConfig = {
        extraPlugins: [ Font ],
        /* fontSize: {
            options: [
                { title: 'Title', model: 'yt-title', view: { name: 'h2', styles: { 'font-size': '24pt' } } },
                { title: 'Description', model: 'yt-description', view: { name: 'p', styles: { 'font-size': '12pt', 'margin-top': '0', 'margin-bottom': '12pt' } } }, // classes: 'description'
            ]
        }, */
        heading: {
            options: [
                { title: 'Title', model: 'heading1', view: { name: 'h2', classes: 'title' } },
                { title: 'Description', model: 'paragraph', view: { classes: 'description' } }
            ]
        },
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'undo', 'redo', {name: 'document', items: ['Source']} ] //  'heading', 'insertTable', 'source'
    }
}
</script>

<style lang="scss" scoped>
.yt-field-ckeditor {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FieldCKEditor.vue